/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CookieNotification } from './CookieNotification';
import {
    CookieNotificationFromJSON,
    CookieNotificationFromJSONTyped,
    CookieNotificationToJSON,
} from './CookieNotification';
import type { DynamicFrontPage } from './DynamicFrontPage';
import {
    DynamicFrontPageFromJSON,
    DynamicFrontPageFromJSONTyped,
    DynamicFrontPageToJSON,
} from './DynamicFrontPage';
import type { INavigation } from './INavigation';
import {
    INavigationFromJSON,
    INavigationFromJSONTyped,
    INavigationToJSON,
} from './INavigation';
import type { INavigationHeader } from './INavigationHeader';
import {
    INavigationHeaderFromJSON,
    INavigationHeaderFromJSONTyped,
    INavigationHeaderToJSON,
} from './INavigationHeader';
import type { ISecondaryNavigationItem } from './ISecondaryNavigationItem';
import {
    ISecondaryNavigationItemFromJSON,
    ISecondaryNavigationItemFromJSONTyped,
    ISecondaryNavigationItemToJSON,
} from './ISecondaryNavigationItem';
import type { ProxyLoginNotification } from './ProxyLoginNotification';
import {
    ProxyLoginNotificationFromJSON,
    ProxyLoginNotificationFromJSONTyped,
    ProxyLoginNotificationToJSON,
} from './ProxyLoginNotification';
import type { Settings } from './Settings';
import {
    SettingsFromJSON,
    SettingsFromJSONTyped,
    SettingsToJSON,
} from './Settings';

/**
 * 
 * @export
 * @interface SiteContent
 */
export interface SiteContent {
    /**
     * 
     * @type {string}
     * @memberof SiteContent
     */
    title?: string;
    /**
     * 
     * @type {Array<INavigationHeader>}
     * @memberof SiteContent
     */
    nav?: Array<INavigationHeader>;
    /**
     * 
     * @type {Array<INavigation>}
     * @memberof SiteContent
     */
    languageNavigation?: Array<INavigation>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SiteContent
     */
    translationKeys?: { [key: string]: string; };
    /**
     * 
     * @type {Settings}
     * @memberof SiteContent
     */
    settings?: Settings;
    /**
     * 
     * @type {CookieNotification}
     * @memberof SiteContent
     */
    cookieNotification?: CookieNotification;
    /**
     * 
     * @type {ProxyLoginNotification}
     * @memberof SiteContent
     */
    proxyLoginNotification?: ProxyLoginNotification;
    /**
     * 
     * @type {DynamicFrontPage}
     * @memberof SiteContent
     */
    frontpageSettings?: DynamicFrontPage;
    /**
     * 
     * @type {number}
     * @memberof SiteContent
     */
    maxDocumentSize?: number;
    /**
     * 
     * @type {Array<ISecondaryNavigationItem>}
     * @memberof SiteContent
     */
    secondaryNav?: Array<ISecondaryNavigationItem>;
}

/**
 * Check if a given object implements the SiteContent interface.
 */
export function instanceOfSiteContent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SiteContentFromJSON(json: any): SiteContent {
    return SiteContentFromJSONTyped(json, false);
}

export function SiteContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiteContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'nav': !exists(json, 'Nav') ? undefined : ((json['Nav'] as Array<any>).map(INavigationHeaderFromJSON)),
        'languageNavigation': !exists(json, 'LanguageNavigation') ? undefined : ((json['LanguageNavigation'] as Array<any>).map(INavigationFromJSON)),
        'translationKeys': !exists(json, 'TranslationKeys') ? undefined : json['TranslationKeys'],
        'settings': !exists(json, 'Settings') ? undefined : SettingsFromJSON(json['Settings']),
        'cookieNotification': !exists(json, 'CookieNotification') ? undefined : CookieNotificationFromJSON(json['CookieNotification']),
        'proxyLoginNotification': !exists(json, 'ProxyLoginNotification') ? undefined : ProxyLoginNotificationFromJSON(json['ProxyLoginNotification']),
        'frontpageSettings': !exists(json, 'FrontpageSettings') ? undefined : DynamicFrontPageFromJSON(json['FrontpageSettings']),
        'maxDocumentSize': !exists(json, 'MaxDocumentSize') ? undefined : json['MaxDocumentSize'],
        'secondaryNav': !exists(json, 'SecondaryNav') ? undefined : ((json['SecondaryNav'] as Array<any>).map(ISecondaryNavigationItemFromJSON)),
    };
}

export function SiteContentToJSON(value?: SiteContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Title': value.title,
        'Nav': value.nav === undefined ? undefined : ((value.nav as Array<any>).map(INavigationHeaderToJSON)),
        'LanguageNavigation': value.languageNavigation === undefined ? undefined : ((value.languageNavigation as Array<any>).map(INavigationToJSON)),
        'TranslationKeys': value.translationKeys,
        'Settings': SettingsToJSON(value.settings),
        'CookieNotification': CookieNotificationToJSON(value.cookieNotification),
        'ProxyLoginNotification': ProxyLoginNotificationToJSON(value.proxyLoginNotification),
        'FrontpageSettings': DynamicFrontPageToJSON(value.frontpageSettings),
        'MaxDocumentSize': value.maxDocumentSize,
        'SecondaryNav': value.secondaryNav === undefined ? undefined : ((value.secondaryNav as Array<any>).map(ISecondaryNavigationItemToJSON)),
    };
}

